module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAdklEQVRIie3TYQqAIAyG4dfot3iE7n+qjmAdoPpTYLKGwiCiPRDI12TSEpxz7muCkO2de3vrARgaN5kblXcTsFZZBGaLeq1xBpYq26zqtcYlaY51lou19O/cvDbj1sbhfJKQXZKQPdI+dRIOFq3q/3ePnXPuew4jyhEumR5I1wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Link_icon_horiz.png
// module id = 453
// module chunks = 0